<template>
  <div class="bulgarian-flag">
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          Независимост
        </div>
      </div>
      <div class="info-box-content">
        означава отговорност!
      </div>
    </div>
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          Аз
        </div>
      </div>
      <div class="info-box-content">
        ще бъда отговорен!
      </div>
    </div>
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          Ниe
        </div>
      </div>
      <div class="info-box-content">
        ще бъдем независими!
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "september22th-slogan-component"
}
</script>

<style scoped>
.info-box {
  width: 350px;
}

.info-box-title {
  flex-basis: 170px;
  height: 80px;
  font-size: 1rem;
  text-transform: uppercase;
}

.bulgarian-flag > div:first-child .info-box-title {
  background: #ffffff;
  color: rgba(0, 0, 0, 0.5);
}

.bulgarian-flag > div:nth-child(2) .info-box-title {
  background: #009900;
}

.bulgarian-flag > div:nth-child(3) .info-box-title {
  background: #CC0000;
}
</style>
